// Module
var code = "<select class=\"sw-country-picker form-control\" ng-model=\"$ctrl.swModel\" ng-disabled=\"$ctrl.swReadOnly\" ng-change=\"$ctrl.change($ctrl.swModel)\"> <option ng-value=\"country.code\" ng-repeat=\"country in $ctrl.countryList\"> {{ country.name }} </option> </select> ";
// Exports
export default code;